import React from "react";
import Header from "./Header";

const TermsAndConditions = () => {
  return (
    <div className="legal-container onway">
        <Header/>
        <div>
            <h1>On the way......</h1>
        </div>
        
    </div>
  );
};

export default TermsAndConditions;
